import { useAPIRequest } from '~/composables/api/useAPIRequest'
import type { EstateType } from '~/types/EstateType'

export async function useEstateDetailData(options: {
  estateType: EstateType
  id: string | number
}) {
  const baseApiUrl = getEstateApiBaseUrl(options.estateType)

  return await useAPIRequest(`${baseApiUrl}/detail/${options.id}`)
}
